@if (isDeliveringWasteAtBerth()) {
  <i style="margin-left: 1em" class="fa fa-recycle" title="Delivering waste" aria-hidden="true"></i>
}
